import { render } from "./user-security-modal.vue?vue&type=template&id=8f4b6cfe"
import script from "./user-security-modal.vue?vue&type=script&lang=js"
export * from "./user-security-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__